import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMDXComponents as _provideComponents } from "@mdx-js/react";
function _createMdxContent(props) {
    const _components = Object.assign({
        main: "main",
        h1: "h1",
        p: "p",
        h2: "h2",
        strong: "strong",
        h3: "h3",
        ul: "ul",
        li: "li",
        a: "a",
        h4: "h4"
    }, _provideComponents(), props.components);
    return _jsxs("main", {
        className: "space-y-4 px-16 py-12 w-[95%] max-w-[60rem]",
        children: [
            _jsx(_components.h1, {
                children: "Privacy Policy"
            }),
            _jsx(_components.p, {
                children: "This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You."
            }),
            _jsx(_components.p, {
                children: "We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy."
            }),
            _jsx(_components.h2, {
                children: _jsx(_components.strong, {
                    children: "Interpretation and Definitions"
                })
            }),
            _jsx(_components.h3, {
                children: _jsx(_components.strong, {
                    children: "Interpretation"
                })
            }),
            _jsx(_components.p, {
                children: "The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural."
            }),
            _jsx(_components.h3, {
                children: _jsx(_components.strong, {
                    children: "Definitions"
                })
            }),
            _jsx(_components.p, {
                children: "For the purposes of this Privacy Policy:"
            }),
            _jsxs(_components.ul, {
                children: [
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Account"
                            }),
                            " means a unique account created for You to access our Service or parts of our Service."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Business"
                            }),
                            ", for the purpose of the CCPA (California Consumer Privacy Act), refers to the Company as the legal entity that collects Consumers' personal information and determines the purposes and means of the processing of Consumers' personal information, or on behalf of which such information is collected and that alone, or jointly with others, determines the purposes and means of the processing of consumers' personal information, that does business in the State of California."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Company"
                            }),
                            ' (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to ONESHOT.EARTH INC, 65 Greene St, NY 10012.\nFor the purpose of the GDPR, the Company is the Data Controller.'
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Consumer"
                            }),
                            ", for the purpose of the CCPA (California Consumer Privacy Act), means a natural person who is a California resident. A resident, as defined in the law, includes (1) every individual who is in the USA for other than a temporary or transitory purpose, and (2) every individual who is domiciled in the USA who is outside the USA for a temporary or transitory purpose."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Cookies"
                            }),
                            " are small files that are placed on Your computer, mobile device or any other device by a website, containing the details of Your browsing history on that website among its many uses."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Country"
                            }),
                            " refers to: New York, United States"
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Data Controller"
                            }),
                            ", for the purposes of the GDPR (General Data Protection Regulation), refers to the Company as the legal person which alone or jointly with others determines the purposes and means of the processing of Personal Data."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Device"
                            }),
                            " means any device that can access the Service such as a computer, a cellphone or a digital tablet."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Do Not Track (DNT)"
                            }),
                            " is a concept that has been promoted by US regulatory authorities, in particular the U.S. Federal Trade Commission (FTC), for the Internet industry to develop and implement a mechanism for allowing internet users to control the tracking of their online activities across websites."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Personal Data"
                            }),
                            " is any information that relates to an identified or identifiable individual.\nFor the purposes of GDPR, Personal Data means any information relating to You such as a name, an identification number, location data, online identifier or to one or more factors specific to the physical, physiological, genetic, mental, economic, cultural or social identity.\nFor the purposes of the CCPA, Personal Data means any information that identifies, relates to, describes or is capable of being associated with, or could reasonably be linked, directly or indirectly, with You."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Sale"
                            }),
                            ", for the purpose of the CCPA (California Consumer Privacy Act), means selling, renting, releasing, disclosing, disseminating, making available, transferring, or otherwise communicating orally, in writing, or by electronic or other means, a Consumer's personal information to another business or a third party for monetary or other valuable consideration."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Service"
                            }),
                            " refers to the Website."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Service Provider"
                            }),
                            " means any natural or legal person who processes the data on behalf of the Company. It refers to third-party companies or individuals employed by the Company to facilitate the Service, to provide the Service on behalf of the Company, to perform services related to the Service or to assist the Company in analyzing how the Service is used. For the purpose of the GDPR, Service Providers are considered Data Processors."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Usage Data"
                            }),
                            " refers to data collected automatically, either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit)."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Website"
                            }),
                            " refers to oneshot.earth, accessible from ",
                            _jsx(_components.a, {
                                href: "https://www.termsfeed.com/live/oneshot.earth",
                                children: "oneshot.earth"
                            })
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "You"
                            }),
                            " means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.\nUnder GDPR (General Data Protection Regulation), You can be referred to as the Data Subject or as the User as you are the individual using the Service."
                        ]
                    }),
                    "\n"
                ]
            }),
            _jsx(_components.h2, {
                children: _jsx(_components.strong, {
                    children: "Collecting and Using Your Personal Data"
                })
            }),
            _jsx(_components.h3, {
                children: _jsx(_components.strong, {
                    children: "Types of Data Collected"
                })
            }),
            _jsx(_components.h4, {
                children: _jsx(_components.strong, {
                    children: "Personal Data"
                })
            }),
            _jsx(_components.p, {
                children: "While using Our Service, We may ask You to provide Us with certain personally identifiable information that can be used to contact or identify You. Personally identifiable information may include, but is not limited to:"
            }),
            _jsxs(_components.ul, {
                children: [
                    "\n",
                    _jsx(_components.li, {
                        children: "Email address"
                    }),
                    "\n",
                    _jsx(_components.li, {
                        children: "First name and last name"
                    }),
                    "\n",
                    _jsx(_components.li, {
                        children: "Usage Data"
                    }),
                    "\n"
                ]
            }),
            _jsx(_components.h4, {
                children: _jsx(_components.strong, {
                    children: "Usage Data"
                })
            }),
            _jsx(_components.p, {
                children: "Usage Data is collected automatically when using the Service."
            }),
            _jsx(_components.p, {
                children: "Usage Data may include information such as Your Device's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that You visit, the time and date of Your visit, the time spent on those pages, unique device identifiers and other diagnostic data."
            }),
            _jsx(_components.p, {
                children: "When You access the Service by or through a mobile device, We may collect certain information automatically, including, but not limited to, the type of mobile device You use, Your mobile device unique ID, the IP address of Your mobile device, Your mobile operating system, the type of mobile Internet browser You use, unique device identifiers and other diagnostic data."
            }),
            _jsx(_components.p, {
                children: "We may also collect information that Your browser sends whenever You visit our Service or when You access the Service by or through a mobile device."
            }),
            _jsx(_components.h4, {
                children: _jsx(_components.strong, {
                    children: "Tracking Technologies and Cookies"
                })
            }),
            _jsx(_components.p, {
                children: "We use Cookies and similar tracking technologies to track the activity on Our Service and store certain information. Tracking technologies used are beacons, tags, and scripts to collect and track information and to improve and analyze Our Service. The technologies We use may include:"
            }),
            _jsxs(_components.ul, {
                children: [
                    "\n",
                    _jsx(_components.li, {
                        children: "Cookies or Browser Cookies. A cookie is a small file placed on Your Device. You can instruct Your browser to refuse all Cookies or to indicate when a Cookie is being sent. However, if You do not accept Cookies, You may not be able to use some parts of our Service. Unless you have adjusted Your browser setting so that it will refuse Cookies, our Service may use Cookies."
                    }),
                    "\n",
                    _jsx(_components.li, {
                        children: "Web Beacons. Certain sections of our Service and our emails may contain small electronic files known as web beacons (also referred to as clear gifs, pixel tags, and single-pixel gifs) that permit the Company, for example, to count users who have visited those pages or opened an email and for other related website statistics (for example, recording the popularity of a certain section and verifying system and server integrity)."
                    }),
                    "\n"
                ]
            }),
            _jsxs(_components.p, {
                children: [
                    'Cookies can be "Persistent" or "Session" Cookies. Persistent Cookies remain on Your personal computer or mobile device when You go offline, while Session Cookies are deleted as soon as You close Your web browser. You can learn more about cookies on ',
                    _jsx(_components.a, {
                        href: "https://www.termsfeed.com/blog/cookies/#What_Are_Cookies",
                        children: "TermsFeed website"
                    }),
                    " article."
                ]
            }),
            _jsx(_components.p, {
                children: "We use both Session and Persistent Cookies for the purposes set out below:"
            }),
            _jsxs(_components.ul, {
                children: [
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Necessary / Essential Cookies"
                            }),
                            "\nType: Session Cookies\nAdministered by: Us\nPurpose: These Cookies are essential to provide You with services available through the Website and to enable You to use some of its features. They help to authenticate users and prevent fraudulent use of user accounts. Without these Cookies, the services that You have asked for cannot be provided, and We only use these Cookies to provide You with those services."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Cookies Policy / Notice Acceptance Cookies"
                            }),
                            "\nType: Persistent Cookies\nAdministered by: Us\nPurpose: These Cookies identify if users have accepted the use of cookies on the Website."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Functionality Cookies"
                            }),
                            "\nType: Persistent Cookies\nAdministered by: Us\nPurpose: These Cookies allow us to remember choices You make when You use the Website, such as remembering your login details or language preference. The purpose of these Cookies is to provide You with a more personal experience and to avoid You having to re-enter your preferences every time You use the Website."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Tracking and Performance Cookies"
                            }),
                            "\nType: Persistent Cookies\nAdministered by: Third-Parties\nPurpose: These Cookies are used to track information about traffic to the Website and how users use the Website. The information gathered via these Cookies may directly or indirectly identify you as an individual visitor. This is because the information collected is typically linked to a pseudonymous identifier associated with the device you use to access the Website. We may also use these Cookies to test new pages, features or new functionality of the Website to see how our users react to them."
                        ]
                    }),
                    "\n"
                ]
            }),
            _jsx(_components.p, {
                children: "For more information about the cookies we use and your choices regarding cookies, please visit our Cookies Policy or the Cookies section of our Privacy Policy."
            }),
            _jsx(_components.h3, {
                children: _jsx(_components.strong, {
                    children: "Use of Your Personal Data"
                })
            }),
            _jsx(_components.p, {
                children: "The Company may use Personal Data for the following purposes:"
            }),
            _jsxs(_components.ul, {
                children: [
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "To provide and maintain our Service"
                            }),
                            ", including to monitor the usage of our Service."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "To manage Your Account"
                            }),
                            ": to manage Your registration as a user of the Service. The Personal Data You provide can give You access to different functionalities of the Service that are available to You as a registered user."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "For the performance of a contract"
                            }),
                            ": the development, compliance and undertaking of the purchase contract for the products, items or services You have purchased or of any other contract with Us through the Service."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "To contact You"
                            }),
                            ": To contact You by email, telephone calls, SMS, or other equivalent forms of electronic communication, such as a mobile application's push notifications regarding updates or informative communications related to the functionalities, products or contracted services, including the security updates, when necessary or reasonable for their implementation."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "To provide You"
                            }),
                            " with news, special offers and general information about other goods, services and events which we offer that are similar to those that you have already purchased or enquired about unless You have opted not to receive such information."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "To manage Your requests"
                            }),
                            ": To attend and manage Your requests to Us."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "For business transfers"
                            }),
                            ": We may use Your information to evaluate or conduct a merger, divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of Our assets, whether as a going concern or as part of bankruptcy, liquidation, or similar proceeding, in which Personal Data held by Us about our Service users is among the assets transferred."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "For other purposes"
                            }),
                            ": We may use Your information for other purposes, such as data analysis, identifying usage trends, determining the effectiveness of our promotional campaigns and to evaluate and improve our Service, products, services, marketing and your experience."
                        ]
                    }),
                    "\n"
                ]
            }),
            _jsx(_components.p, {
                children: "We may share Your personal information in the following situations:"
            }),
            _jsxs(_components.ul, {
                children: [
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "With Service Providers"
                            }),
                            ": We may share Your personal information with Service Providers to monitor and analyze the use of our Service, for payment processing, to contact You."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "For business transfers"
                            }),
                            ": We may share or transfer Your personal information in connection with, or during negotiations of, any merger, sale of Company assets, financing, or acquisition of all or a portion of Our business to another company."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "With Affiliates"
                            }),
                            ": We may share Your information with Our affiliates, in which case we will require those affiliates to honor this Privacy Policy. Affiliates include Our parent company and any other subsidiaries, joint venture partners or other companies that We control or that are under common control with Us."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "With business partners"
                            }),
                            ": We may share Your information with Our business partners to offer You certain products, services or promotions."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "With other users"
                            }),
                            ": when You share personal information or otherwise interact in the public areas with other users, such information may be viewed by all users and may be publicly distributed outside."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "With Your consent"
                            }),
                            ": We may disclose Your personal information for any other purpose with Your consent."
                        ]
                    }),
                    "\n"
                ]
            }),
            _jsx(_components.h3, {
                children: _jsx(_components.strong, {
                    children: "Retention of Your Personal Data"
                })
            }),
            _jsx(_components.p, {
                children: "The Company will retain Your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use Your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies."
            }),
            _jsx(_components.p, {
                children: "The Company will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period of time, except when this data is used to strengthen the security or to improve the functionality of Our Service, or We are legally obligated to retain this data for longer time periods."
            }),
            _jsx(_components.h3, {
                children: _jsx(_components.strong, {
                    children: "Transfer of Your Personal Data"
                })
            }),
            _jsx(_components.p, {
                children: "Your information, including Personal Data, is processed at the Company's operating offices and in any other places where the parties involved in the processing are located. It means that this information may be transferred to — and maintained on — computers located outside of Your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from Your jurisdiction."
            }),
            _jsx(_components.p, {
                children: "Your consent to this Privacy Policy followed by Your submission of such information represents Your agreement to that transfer."
            }),
            _jsx(_components.p, {
                children: "The Company will take all steps reasonably necessary to ensure that Your data is treated securely and in accordance with this Privacy Policy and no transfer of Your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of Your data and other personal information."
            }),
            _jsx(_components.h3, {
                children: _jsx(_components.strong, {
                    children: "Delete Your Personal Data"
                })
            }),
            _jsx(_components.p, {
                children: "You have the right to delete or request that We assist in deleting the Personal Data that We have collected about You."
            }),
            _jsx(_components.p, {
                children: "Our Service may give You the ability to delete certain information about You from within the Service."
            }),
            _jsx(_components.p, {
                children: "You may update, amend, or delete Your information at any time by signing in to Your Account, if you have one, and visiting the account settings section that allows you to manage Your personal information. You may also contact Us to request access to, correct, or delete any personal information that You have provided to Us."
            }),
            _jsx(_components.p, {
                children: "Please note, however, that We may need to retain certain information when we have a legal obligation or lawful basis to do so."
            }),
            _jsx(_components.h3, {
                children: _jsx(_components.strong, {
                    children: "Disclosure of Your Personal Data"
                })
            }),
            _jsx(_components.h4, {
                children: _jsx(_components.strong, {
                    children: "Business Transactions"
                })
            }),
            _jsx(_components.p, {
                children: "If the Company is involved in a merger, acquisition or asset sale, Your Personal Data may be transferred. We will provide notice before Your Personal Data is transferred and becomes subject to a different Privacy Policy."
            }),
            _jsx(_components.h4, {
                children: _jsx(_components.strong, {
                    children: "Law enforcement"
                })
            }),
            _jsx(_components.p, {
                children: "Under certain circumstances, the Company may be required to disclose Your Personal Data if required to do so by law or in response to valid requests by public authorities (e.g. a court or a government agency)."
            }),
            _jsx(_components.h4, {
                children: _jsx(_components.strong, {
                    children: "Other legal requirements"
                })
            }),
            _jsx(_components.p, {
                children: "The Company may disclose Your Personal Data in the good faith belief that such action is necessary to:"
            }),
            _jsxs(_components.ul, {
                children: [
                    "\n",
                    _jsx(_components.li, {
                        children: "Comply with a legal obligation"
                    }),
                    "\n",
                    _jsx(_components.li, {
                        children: "Protect and defend the rights or property of the Company"
                    }),
                    "\n",
                    _jsx(_components.li, {
                        children: "Prevent or investigate possible wrongdoing in connection with the Service"
                    }),
                    "\n",
                    _jsx(_components.li, {
                        children: "Protect the personal safety of Users of the Service or the public"
                    }),
                    "\n",
                    _jsx(_components.li, {
                        children: "Protect against legal liability"
                    }),
                    "\n"
                ]
            }),
            _jsx(_components.h3, {
                children: _jsx(_components.strong, {
                    children: "Security of Your Personal Data"
                })
            }),
            _jsx(_components.p, {
                children: "The security of Your Personal Data is important to Us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While We strive to use commercially acceptable means to protect Your Personal Data, We cannot guarantee its absolute security."
            }),
            _jsx(_components.h2, {
                children: _jsx(_components.strong, {
                    children: "Detailed Information on the Processing of Your Personal Data"
                })
            }),
            _jsx(_components.p, {
                children: "The Service Providers We use may have access to Your Personal Data. These third-party vendors collect, store, use, process and transfer information about Your activity on Our Service in accordance with their Privacy Policies."
            }),
            _jsx(_components.h3, {
                children: _jsx(_components.strong, {
                    children: "Analytics"
                })
            }),
            _jsx(_components.p, {
                children: "We may use third-party Service providers to monitor and analyze the use of our Service."
            }),
            _jsxs(_components.ul, {
                children: [
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Google Analytics"
                            }),
                            "\nGoogle Analytics is a web analytics service offered by Google that tracks and reports website traffic. Google uses the data collected to track and monitor the use of our Service. This data is shared with other Google services. Google may use the collected data to contextualize and personalize the ads of its own advertising network.\nYou can opt-out of having made your activity on the Service available to Google Analytics by installing the Google Analytics opt-out browser add-on. The add-on prevents the Google Analytics JavaScript (ga.js, analytics.js and dc.js) from sharing information with Google Analytics about visits activity.\nFor more information on the privacy practices of Google, please visit the Google Privacy & Terms web page: ",
                            _jsx(_components.a, {
                                href: "https://policies.google.com/privacy",
                                children: "https://policies.google.com/privacy"
                            })
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Matomo"
                            }),
                            "\nMatomo is a web analytics service. You can visit their Privacy Policy page here: ",
                            _jsx(_components.a, {
                                href: "https://matomo.org/privacy-policy",
                                children: "https://matomo.org/privacy-policy"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            _jsx(_components.h3, {
                children: _jsx(_components.strong, {
                    children: "Email Marketing"
                })
            }),
            _jsx(_components.p, {
                children: "We may use Your Personal Data to contact You with newsletters, marketing or promotional materials and other information that may be of interest to You. You may opt-out of receiving any, or all, of these communications from Us by following the unsubscribe link or instructions provided in any email We send or by contacting Us."
            }),
            _jsx(_components.p, {
                children: "We may use Email Marketing Service Providers to manage and send emails to You."
            }),
            _jsxs(_components.ul, {
                children: [
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Mailchimp"
                            }),
                            "\nMailchimp is an email marketing sending service provided by The Rocket Science Group LLC.\nFor more information on the privacy practices of Mailchimp, please visit their Privacy policy: ",
                            _jsx(_components.a, {
                                href: "https://mailchimp.com/legal/privacy/",
                                children: "https://mailchimp.com/legal/privacy/"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            _jsx(_components.h3, {
                children: _jsx(_components.strong, {
                    children: "Payments"
                })
            }),
            _jsx(_components.p, {
                children: "We may provide paid products and/or services within the Service. In that case, we may use third-party services for payment processing (e.g. payment processors)."
            }),
            _jsx(_components.p, {
                children: "We will not store or collect Your payment card details. That information is provided directly to Our third-party payment processors whose use of Your personal information is governed by their Privacy Policy. These payment processors adhere to the standards set by PCI-DSS as managed by the PCI Security Standards Council, which is a joint effort of brands like Visa, Mastercard, American Express and Discover. PCI-DSS requirements help ensure the secure handling of payment information."
            }),
            _jsxs(_components.ul, {
                children: [
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Stripe"
                            }),
                            "\nTheir Privacy Policy can be viewed at ",
                            _jsx(_components.a, {
                                href: "https://stripe.com/us/privacy",
                                children: "https://stripe.com/us/privacy"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            _jsx(_components.h2, {
                children: _jsx(_components.strong, {
                    children: "GDPR Privacy"
                })
            }),
            _jsx(_components.h2, {
                children: _jsx(_components.strong, {
                    children: "Legal Basis for Processing Personal Data under GDPR"
                })
            }),
            _jsx(_components.p, {
                children: "We may process Personal Data under the following conditions:"
            }),
            _jsxs(_components.ul, {
                children: [
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Consent"
                            }),
                            ": You have given Your consent for processing Personal Data for one or more specific purposes."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Performance of a contract"
                            }),
                            ": Provision of Personal Data is necessary for the performance of an agreement with You and/or for any pre-contractual obligations thereof."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Legal obligations"
                            }),
                            ": Processing Personal Data is necessary for compliance with a legal obligation to which the Company is subject."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Vital interests"
                            }),
                            ": Processing Personal Data is necessary in order to protect Your vital interests or of another natural person."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Public interests"
                            }),
                            ": Processing Personal Data is related to a task that is carried out in the public interest or in the exercise of official authority vested in the Company."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Legitimate interests"
                            }),
                            ": Processing Personal Data is necessary for the purposes of the legitimate interests pursued by the Company."
                        ]
                    }),
                    "\n"
                ]
            }),
            _jsx(_components.p, {
                children: "In any case, the Company will gladly help to clarify the specific legal basis that applies to the processing, and in particular whether the provision of Personal Data is a statutory or contractual requirement, or a requirement necessary to enter into a contract."
            }),
            _jsx(_components.h3, {
                children: _jsx(_components.strong, {
                    children: "Your Rights under the GDPR"
                })
            }),
            _jsx(_components.p, {
                children: "The Company undertakes to respect the confidentiality of Your Personal Data and to guarantee You can exercise Your rights."
            }),
            _jsx(_components.p, {
                children: "You have the right under this Privacy Policy, and by law if You are within the EU, to:"
            }),
            _jsxs(_components.ul, {
                children: [
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Request access to Your Personal Data"
                            }),
                            ". The right to access, update or delete the information We have on You. Whenever made possible, you can access, update or request deletion of Your Personal Data directly within Your account settings section. If you are unable to perform these actions yourself, please contact Us to assist You. This also enables You to receive a copy of the Personal Data We hold about You."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Request correction of the Personal Data that We hold about You"
                            }),
                            ". You have the right to have any incomplete or inaccurate information We hold about You corrected."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Object to processing of Your Personal Data"
                            }),
                            ". This right exists where We are relying on a legitimate interest as the legal basis for Our processing and there is something about Your particular situation, which makes You want to object to our processing of Your Personal Data on this ground. You also have the right to object where We are processing Your Personal Data for direct marketing purposes."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Request erasure of Your Personal Data"
                            }),
                            ". You have the right to ask Us to delete or remove Personal Data when there is no good reason for Us to continue processing it."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Request the transfer of Your Personal Data"
                            }),
                            ". We will provide to You, or to a third-party You have chosen, Your Personal Data in a structured, commonly used, machine-readable format. Please note that this right only applies to automated information which You initially provided consent for Us to use or where We used the information to perform a contract with You."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Withdraw Your consent"
                            }),
                            ". You have the right to withdraw Your consent on using your Personal Data. If You withdraw Your consent, We may not be able to provide You with access to certain specific functionalities of the Service."
                        ]
                    }),
                    "\n"
                ]
            }),
            _jsx(_components.h3, {
                children: _jsx(_components.strong, {
                    children: "Exercising of Your GDPR Data Protection Rights"
                })
            }),
            _jsx(_components.p, {
                children: "You may exercise Your rights of access, rectification, cancellation and opposition by contacting Us. Please note that we may ask You to verify Your identity before responding to such requests. If You make a request, We will try our best to respond to You as soon as possible."
            }),
            _jsx(_components.p, {
                children: "You have the right to complain to a Data Protection Authority about Our collection and use of Your Personal Data. For more information, if You are in the European Economic Area (EEA), please contact Your local data protection authority in the EEA."
            }),
            _jsx(_components.h2, {
                children: _jsx(_components.strong, {
                    children: "CCPA Privacy"
                })
            }),
            _jsx(_components.p, {
                children: "This privacy notice section for California residents supplements the information contained in Our Privacy Policy and it applies solely to all visitors, users, and others who reside in the State of California."
            }),
            _jsx(_components.h3, {
                children: _jsx(_components.strong, {
                    children: "Categories of Personal Information Collected"
                })
            }),
            _jsx(_components.p, {
                children: "We collect information that identifies, relates to, describes, references, is capable of being associated with, or could reasonably be linked, directly or indirectly, with a particular Consumer or Device. The following is a list of categories of personal information which we may collect or may have been collected from California residents within the last twelve (12) months."
            }),
            _jsx(_components.p, {
                children: "Please note that the categories and examples provided in the list below are those defined in the CCPA. This does not mean that all examples of that category of personal information were in fact collected by Us, but reflects our good faith belief to the best of our knowledge that some of that information from the applicable category may be and may have been collected. For example, certain categories of personal information would only be collected if You provided such personal information directly to Us."
            }),
            _jsxs(_components.ul, {
                children: [
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Category A: Identifiers."
                            }),
                            "\nExamples: A real name, alias, postal address, unique personal identifier, online identifier, Internet Protocol address, email address, account name, driver's license number, passport number, or other similar identifiers.\nCollected: Yes."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Category B:"
                            }),
                            " Personal information categories listed in the California Customer Records statute (Cal. Civ. Code § 1798.80(e)).\nExamples: A name, signature, Social Security number, physical characteristics or description, address, telephone number, passport number, driver's license or state identification card number, insurance policy number, education, employment, employment history, bank account number, credit card number, debit card number, or any other financial information, medical information, or health insurance information. Some personal information included in this category may overlap with other categories.\nCollected: Yes."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Category C: Protected classification characteristics under California or federal law."
                            }),
                            "\nExamples: Age (40 years or older), race, color, ancestry, national origin, citizenship, religion or creed, marital status, medical condition, physical or mental disability, sex (including gender, gender identity, gender expression, pregnancy or childbirth and related medical conditions), sexual orientation, veteran or military status, genetic information (including familial genetic information).\nCollected: No."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Category D: Commercial information."
                            }),
                            "\nExamples: Records and history of products or services purchased or considered.\nCollected: Yes."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Category E: Biometric information."
                            }),
                            "\nExamples: Genetic, physiological, behavioral, and biological characteristics, or activity patterns used to extract a template or other identifier or identifying information, such as, fingerprints, faceprints, and voiceprints, iris or retina scans, keystroke, gait, or other physical patterns, and sleep, health, or exercise data.\nCollected: No."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Category F: Internet or other similar network activity."
                            }),
                            "\nExamples: Interaction with our Service or advertisement.\nCollected: Yes."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Category G: Geolocation data."
                            }),
                            "\nExamples: Approximate physical location.\nCollected: No."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Category H: Sensory data."
                            }),
                            "\nExamples: Audio, electronic, visual, thermal, olfactory, or similar information.\nCollected: No."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Category I: Professional or employment-related information."
                            }),
                            "\nExamples: Current or past job history or performance evaluations.\nCollected: No."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Category J: Non-public education information (per the Family Educational Rights and Privacy Act (20 U.S.C. Section 1232g, 34 C.F.R. Part 99))."
                            }),
                            "\nExamples: Education records directly related to a student maintained by an educational institution or party acting on its behalf, such as grades, transcripts, class lists, student schedules, student identification codes, student financial information, or student disciplinary records.\nCollected: No."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Category K: Inferences drawn from other personal information."
                            }),
                            "\nExamples: Profile reflecting a person's preferences, characteristics, psychological trends, predispositions, behavior, attitudes, intelligence, abilities, and aptitudes.\nCollected: No."
                        ]
                    }),
                    "\n"
                ]
            }),
            _jsx(_components.p, {
                children: "Under CCPA, personal information does not include:"
            }),
            _jsxs(_components.ul, {
                children: [
                    "\n",
                    _jsx(_components.li, {
                        children: "Publicly available information from government records"
                    }),
                    "\n",
                    _jsx(_components.li, {
                        children: "Deidentified or aggregated consumer information"
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            "Information excluded from the CCPA's scope, such as:",
                            "\n",
                            _jsxs(_components.ul, {
                                children: [
                                    "\n",
                                    _jsx(_components.li, {
                                        children: "Health or medical information covered by the Health Insurance Portability and Accountability Act of 1996 (HIPAA) and the California Confidentiality of Medical Information Act (CMIA) or clinical trial data"
                                    }),
                                    "\n",
                                    _jsx(_components.li, {
                                        children: "Personal Information covered by certain sector-specific privacy laws, including the Fair Credit Reporting Act (FRCA), the Gramm-Leach-Bliley Act (GLBA) or California Financial Information Privacy Act (FIPA), and the Driver's Privacy Protection Act of 1994"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            _jsx(_components.h3, {
                children: _jsx(_components.strong, {
                    children: "Sources of Personal Information"
                })
            }),
            _jsx(_components.p, {
                children: "We obtain the categories of personal information listed above from the following categories of sources:"
            }),
            _jsxs(_components.ul, {
                children: [
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Directly from You"
                            }),
                            ". For example, from the forms You complete on our Service, preferences You express or provide through our Service, or from Your purchases on our Service."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Indirectly from You"
                            }),
                            ". For example, from observing Your activity on our Service."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "Automatically from You"
                            }),
                            ". For example, through cookies We or our Service Providers set on Your Device as You navigate through our Service."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "From Service Providers"
                            }),
                            ". For example, third-party vendors to monitor and analyze the use of our Service, third-party vendors for payment processing, or other third-party vendors that We use to provide the Service to You."
                        ]
                    }),
                    "\n"
                ]
            }),
            _jsx(_components.h3, {
                children: _jsx(_components.strong, {
                    children: "Use of Personal Information for Business Purposes or Commercial Purposes"
                })
            }),
            _jsx(_components.p, {
                children: 'We may use or disclose personal information We collect for "business purposes" or "commercial purposes" (as defined under the CCPA), which may include the following examples:'
            }),
            _jsxs(_components.ul, {
                children: [
                    "\n",
                    _jsx(_components.li, {
                        children: "To operate our Service and provide You with our Service."
                    }),
                    "\n",
                    _jsx(_components.li, {
                        children: "To provide You with support and to respond to Your inquiries, including to investigate and address Your concerns and monitor and improve our Service."
                    }),
                    "\n",
                    _jsx(_components.li, {
                        children: "To fulfill or meet the reason You provided the information. For example, if You share Your contact information to ask a question about our Service, We will use that personal information to respond to Your inquiry. If You provide Your personal information to purchase a product or service, We will use that information to process Your payment and facilitate delivery."
                    }),
                    "\n",
                    _jsx(_components.li, {
                        children: "To respond to law enforcement requests and as required by applicable law, court order, or governmental regulations."
                    }),
                    "\n",
                    _jsx(_components.li, {
                        children: "As described to You when collecting Your personal information or as otherwise set forth in the CCPA."
                    }),
                    "\n",
                    _jsx(_components.li, {
                        children: "For internal administrative and auditing purposes."
                    }),
                    "\n",
                    _jsx(_components.li, {
                        children: "To detect security incidents and protect against malicious, deceptive, fraudulent or illegal activity, including, when necessary, to prosecute those responsible for such activities."
                    }),
                    "\n"
                ]
            }),
            _jsx(_components.p, {
                children: 'Please note that the examples provided above are illustrative and not intended to be exhaustive. For more details on how we use this information, please refer to the "Use of Your Personal Data" section.'
            }),
            _jsx(_components.p, {
                children: "If We decide to collect additional categories of personal information or use the personal information We collected for materially different, unrelated, or incompatible purposes We will update this Privacy Policy."
            }),
            _jsx(_components.h3, {
                children: _jsx(_components.strong, {
                    children: "Disclosure of Personal Information for Business Purposes or Commercial Purposes"
                })
            }),
            _jsx(_components.p, {
                children: "We may use or disclose and may have used or disclosed in the last twelve (12) months the following categories of personal information for business or commercial purposes:"
            }),
            _jsxs(_components.ul, {
                children: [
                    "\n",
                    _jsx(_components.li, {
                        children: "Category A: Identifiers"
                    }),
                    "\n",
                    _jsx(_components.li, {
                        children: "Category B: Personal information categories listed in the California Customer Records statute (Cal. Civ. Code § 1798.80(e))"
                    }),
                    "\n",
                    _jsx(_components.li, {
                        children: "Category D: Commercial information"
                    }),
                    "\n",
                    _jsx(_components.li, {
                        children: "Category F: Internet or other similar network activity"
                    }),
                    "\n"
                ]
            }),
            _jsx(_components.p, {
                children: "Please note that the categories listed above are those defined in the CCPA. This does not mean that all examples of that category of personal information were in fact disclosed, but reflects our good faith belief to the best of our knowledge that some of that information from the applicable category may be and may have been disclosed."
            }),
            _jsx(_components.p, {
                children: "When We disclose personal information for a business purpose or a commercial purpose, We enter a contract that describes the purpose and requires the recipient to both keep that personal information confidential and not use it for any purpose except performing the contract."
            }),
            _jsx(_components.h3, {
                children: _jsx(_components.strong, {
                    children: "Sale of Personal Information"
                })
            }),
            _jsx(_components.p, {
                children: 'As defined in the CCPA, "sell" and "sale" mean selling, renting, releasing, disclosing, disseminating, making available, transferring, or otherwise communicating orally, in writing, or by electronic or other means, a consumer\'s personal information by the business to a third party for valuable consideration. This means that We may have received some kind of benefit in return for sharing personal information, but not necessarily a monetary benefit.'
            }),
            _jsx(_components.p, {
                children: "Please note that the categories listed below are those defined in the CCPA. This does not mean that all examples of that category of personal information were in fact sold, but reflects our good faith belief to the best of our knowledge that some of that information from the applicable category may be and may have been shared for value in return."
            }),
            _jsx(_components.p, {
                children: "We may sell and may have sold in the last twelve (12) months the following categories of personal information:"
            }),
            _jsxs(_components.ul, {
                children: [
                    "\n",
                    _jsx(_components.li, {
                        children: "Category A: Identifiers"
                    }),
                    "\n",
                    _jsx(_components.li, {
                        children: "Category B: Personal information categories listed in the California Customer Records statute (Cal. Civ. Code § 1798.80(e))"
                    }),
                    "\n",
                    _jsx(_components.li, {
                        children: "Category D: Commercial information"
                    }),
                    "\n",
                    _jsx(_components.li, {
                        children: "Category F: Internet or other similar network activity"
                    }),
                    "\n"
                ]
            }),
            _jsx(_components.h3, {
                children: _jsx(_components.strong, {
                    children: "Share of Personal Information"
                })
            }),
            _jsx(_components.p, {
                children: "We may share Your personal information identified in the above categories with the following categories of third parties:"
            }),
            _jsxs(_components.ul, {
                children: [
                    "\n",
                    _jsx(_components.li, {
                        children: "Service Providers"
                    }),
                    "\n",
                    _jsx(_components.li, {
                        children: "Payment processors"
                    }),
                    "\n",
                    _jsx(_components.li, {
                        children: "Our affiliates"
                    }),
                    "\n",
                    _jsx(_components.li, {
                        children: "Our business partners"
                    }),
                    "\n",
                    _jsx(_components.li, {
                        children: "Third party vendors to whom You or Your agents authorize Us to disclose Your personal information in connection with products or services We provide to You"
                    }),
                    "\n"
                ]
            }),
            _jsx(_components.h3, {
                children: _jsx(_components.strong, {
                    children: "Sale of Personal Information of Minors Under 16 Years of Age"
                })
            }),
            _jsx(_components.p, {
                children: "We do not knowingly collect personal information from minors under the age of 16 through our Service, although certain third party websites that we link to may do so. These third-party websites have their own terms of use and privacy policies and we encourage parents and legal guardians to monitor their children's Internet usage and instruct their children to never provide information on other websites without their permission."
            }),
            _jsx(_components.p, {
                children: 'We do not sell the personal information of Consumers We actually know are less than 16 years of age, unless We receive affirmative authorization (the "right to opt-in") from either the Consumer who is between 13 and 16 years of age, or the parent or guardian of a Consumer less than 13 years of age. Consumers who opt-in to the sale of personal information may opt-out of future sales at any time. To exercise the right to opt-out, You (or Your authorized representative) may submit a request to Us by contacting Us.'
            }),
            _jsx(_components.p, {
                children: "If You have reason to believe that a child under the age of 13 (or 16) has provided Us with personal information, please contact Us with sufficient detail to enable Us to delete that information."
            }),
            _jsx(_components.h3, {
                children: _jsx(_components.strong, {
                    children: "Your Rights under the CCPA"
                })
            }),
            _jsx(_components.p, {
                children: "The CCPA provides California residents with specific rights regarding their personal information. If You are a resident of California, You have the following rights:"
            }),
            _jsxs(_components.ul, {
                children: [
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "The right to notice"
                            }),
                            ". You have the right to be notified which categories of Personal Data are being collected and the purposes for which the Personal Data is being used."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "The right to request"
                            }),
                            ". Under CCPA, You have the right to request that We disclose information to You about Our collection, use, sale, disclosure for business purposes and share of personal information. Once We receive and confirm Your request, We will disclose to You:",
                            "\n",
                            _jsxs(_components.ul, {
                                children: [
                                    "\n",
                                    _jsx(_components.li, {
                                        children: "The categories of personal information We collected about You"
                                    }),
                                    "\n",
                                    _jsx(_components.li, {
                                        children: "The categories of sources for the personal information We collected about You"
                                    }),
                                    "\n",
                                    _jsx(_components.li, {
                                        children: "Our business or commercial purpose for collecting or selling that personal information"
                                    }),
                                    "\n",
                                    _jsx(_components.li, {
                                        children: "The categories of third parties with whom We share that personal information"
                                    }),
                                    "\n",
                                    _jsx(_components.li, {
                                        children: "The specific pieces of personal information We collected about You"
                                    }),
                                    "\n",
                                    _jsxs(_components.li, {
                                        children: [
                                            "If we sold Your personal information or disclosed Your personal information for a business purpose, We will disclose to You:",
                                            "\n",
                                            _jsxs(_components.ul, {
                                                children: [
                                                    "\n",
                                                    _jsx(_components.li, {
                                                        children: "The categories of personal information categories sold"
                                                    }),
                                                    "\n",
                                                    _jsx(_components.li, {
                                                        children: "The categories of personal information categories disclosed"
                                                    }),
                                                    "\n"
                                                ]
                                            }),
                                            "\n"
                                        ]
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "The right to say no to the sale of Personal Data (opt-out)"
                            }),
                            ". You have the right to direct Us to not sell Your personal information. To submit an opt-out request please contact Us."
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "The right to delete Personal Data"
                            }),
                            ". You have the right to request the deletion of Your Personal Data, subject to certain exceptions. Once We receive and confirm Your request, We will delete (and direct Our Service Providers to delete) Your personal information from our records, unless an exception applies. We may deny Your deletion request if retaining the information is necessary for Us or Our Service Providers to:",
                            "\n",
                            _jsxs(_components.ul, {
                                children: [
                                    "\n",
                                    _jsx(_components.li, {
                                        children: "Complete the transaction for which We collected the personal information, provide a good or service that You requested, take actions reasonably anticipated within the context of our ongoing business relationship with You, or otherwise perform our contract with You."
                                    }),
                                    "\n",
                                    _jsx(_components.li, {
                                        children: "Detect security incidents, protect against malicious, deceptive, fraudulent, or illegal activity, or prosecute those responsible for such activities."
                                    }),
                                    "\n",
                                    _jsx(_components.li, {
                                        children: "Debug products to identify and repair errors that impair existing intended functionality."
                                    }),
                                    "\n",
                                    _jsx(_components.li, {
                                        children: "Exercise free speech, ensure the right of another consumer to exercise their free speech rights, or exercise another right provided for by law."
                                    }),
                                    "\n",
                                    _jsx(_components.li, {
                                        children: "Comply with the California Electronic Communications Privacy Act (Cal. Penal Code § 1546 et. seq.)."
                                    }),
                                    "\n",
                                    _jsx(_components.li, {
                                        children: "Engage in public or peer-reviewed scientific, historical, or statistical research in the public interest that adheres to all other applicable ethics and privacy laws, when the information's deletion may likely render impossible or seriously impair the research's achievement, if You previously provided informed consent."
                                    }),
                                    "\n",
                                    _jsx(_components.li, {
                                        children: "Enable solely internal uses that are reasonably aligned with consumer expectations based on Your relationship with Us."
                                    }),
                                    "\n",
                                    _jsx(_components.li, {
                                        children: "Comply with a legal obligation."
                                    }),
                                    "\n",
                                    _jsx(_components.li, {
                                        children: "Make other internal and lawful uses of that information that are compatible with the context in which You provided it."
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            _jsx(_components.strong, {
                                children: "The right not to be discriminated against"
                            }),
                            ". You have the right not to be discriminated against for exercising any of Your consumer's rights, including by:",
                            "\n",
                            _jsxs(_components.ul, {
                                children: [
                                    "\n",
                                    _jsx(_components.li, {
                                        children: "Denying goods or services to You"
                                    }),
                                    "\n",
                                    _jsx(_components.li, {
                                        children: "Charging different prices or rates for goods or services, including the use of discounts or other benefits or imposing penalties"
                                    }),
                                    "\n",
                                    _jsx(_components.li, {
                                        children: "Providing a different level or quality of goods or services to You"
                                    }),
                                    "\n",
                                    _jsx(_components.li, {
                                        children: "Suggesting that You will receive a different price or rate for goods or services or a different level or quality of goods or services"
                                    }),
                                    "\n"
                                ]
                            }),
                            "\n"
                        ]
                    }),
                    "\n"
                ]
            }),
            _jsx(_components.h3, {
                children: _jsx(_components.strong, {
                    children: "Exercising Your CCPA Data Protection Rights"
                })
            }),
            _jsx(_components.p, {
                children: "In order to exercise any of Your rights under the CCPA, and if You are a California resident, You can contact Us:"
            }),
            _jsxs(_components.ul, {
                children: [
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            "By visiting this page on our website: ",
                            _jsx(_components.a, {
                                href: "https://www.termsfeed.com/live/oneshot.earth/contact",
                                children: "oneshot.earth/contact"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            _jsx(_components.p, {
                children: "Only You, or a person registered with the California Secretary of State that You authorize to act on Your behalf, may make a verifiable request related to Your personal information."
            }),
            _jsx(_components.p, {
                children: "Your request to Us must:"
            }),
            _jsxs(_components.ul, {
                children: [
                    "\n",
                    _jsx(_components.li, {
                        children: "Provide sufficient information that allows Us to reasonably verify You are the person about whom We collected personal information or an authorized representative"
                    }),
                    "\n",
                    _jsx(_components.li, {
                        children: "Describe Your request with sufficient detail that allows Us to properly understand, evaluate, and respond to it"
                    }),
                    "\n"
                ]
            }),
            _jsx(_components.p, {
                children: "We cannot respond to Your request or provide You with the required information if We cannot:"
            }),
            _jsxs(_components.ul, {
                children: [
                    "\n",
                    _jsx(_components.li, {
                        children: "Verify Your identity or authority to make the request"
                    }),
                    "\n",
                    _jsx(_components.li, {
                        children: "And confirm that the personal information relates to You"
                    }),
                    "\n"
                ]
            }),
            _jsx(_components.p, {
                children: "We will disclose and deliver the required information free of charge within 45 days of receiving Your verifiable request. The time period to provide the required information may be extended once by an additional 45 days when reasonably necessary and with prior notice."
            }),
            _jsx(_components.p, {
                children: "Any disclosures We provide will only cover the 12-month period preceding the verifiable request's receipt."
            }),
            _jsx(_components.p, {
                children: "For data portability requests, We will select a format to provide Your personal information that is readily usable and should allow You to transmit the information from one entity to another entity without hindrance."
            }),
            _jsx(_components.h3, {
                children: _jsx(_components.strong, {
                    children: "Do Not Sell My Personal Information"
                })
            }),
            _jsx(_components.p, {
                children: "You have the right to opt-out of the sale of Your personal information. Once We receive and confirm a verifiable consumer request from You, we will stop selling Your personal information. To exercise Your right to opt-out, please contact Us."
            }),
            _jsx(_components.p, {
                children: "The Service Providers we partner with (for example, our analytics or advertising partners) may use technology on the Service that sells personal information as defined by the CCPA law. If you wish to opt out of the use of Your personal information for interest-based advertising purposes and these potential sales as defined under CCPA law, you may do so by following the instructions below."
            }),
            _jsx(_components.p, {
                children: "Please note that any opt out is specific to the browser You use. You may need to opt out on every browser that You use."
            }),
            _jsx(_components.h4, {
                children: _jsx(_components.strong, {
                    children: "Website"
                })
            }),
            _jsx(_components.p, {
                children: "You can opt out of receiving ads that are personalized as served by our Service Providers by following our instructions presented on the Service:"
            }),
            _jsxs(_components.ul, {
                children: [
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            "The NAI's opt-out platform: ",
                            _jsx(_components.a, {
                                href: "http://www.networkadvertising.org/choices/",
                                children: "http://www.networkadvertising.org/choices/"
                            })
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            "The EDAA's opt-out platform: ",
                            _jsx(_components.a, {
                                href: "http://www.youronlinechoices.com/",
                                children: "http://www.youronlinechoices.com/"
                            })
                        ]
                    }),
                    "\n",
                    _jsxs(_components.li, {
                        children: [
                            "The DAA's opt-out platform: ",
                            _jsx(_components.a, {
                                href: "http://optout.aboutads.info/?c=2&amp;lang=EN",
                                children: "http://optout.aboutads.info/?c=2&lang=EN"
                            })
                        ]
                    }),
                    "\n"
                ]
            }),
            _jsx(_components.p, {
                children: "The opt out will place a cookie on Your computer that is unique to the browser You use to opt out. If you change browsers or delete the cookies saved by your browser, You will need to opt out again."
            }),
            _jsx(_components.h4, {
                children: _jsx(_components.strong, {
                    children: "Mobile Devices"
                })
            }),
            _jsx(_components.p, {
                children: "Your mobile device may give You the ability to opt out of the use of information about the apps You use in order to serve You ads that are targeted to Your interests:"
            }),
            _jsxs(_components.ul, {
                children: [
                    "\n",
                    _jsx(_components.li, {
                        children: '"Opt out of Interest-Based Ads" or "Opt out of Ads Personalization" on Android devices'
                    }),
                    "\n",
                    _jsx(_components.li, {
                        children: '"Limit Ad Tracking" on iOS devices'
                    }),
                    "\n"
                ]
            }),
            _jsx(_components.p, {
                children: "You can also stop the collection of location information from Your mobile device by changing the preferences on Your mobile device."
            }),
            _jsx(_components.h2, {
                children: _jsx(_components.strong, {
                    children: '"Do Not Track" Policy as Required by California Online Privacy Protection Act (CalOPPA)'
                })
            }),
            _jsx(_components.p, {
                children: "Our Service does not respond to Do Not Track signals."
            }),
            _jsx(_components.p, {
                children: "However, some third party websites do keep track of Your browsing activities. If You are visiting such websites, You can set Your preferences in Your web browser to inform websites that You do not want to be tracked. You can enable or disable DNT by visiting the preferences or settings page of Your web browser."
            }),
            _jsx(_components.h2, {
                children: _jsx(_components.strong, {
                    children: "Children's Privacy"
                })
            }),
            _jsx(_components.p, {
                children: "Our Service does not address anyone under the age of 13. We do not knowingly collect personally identifiable information from anyone under the age of 13. If You are a parent or guardian and You are aware that Your child has provided Us with Personal Data, please contact Us. If We become aware that We have collected Personal Data from anyone under the age of 13 without verification of parental consent, We take steps to remove that information from Our servers."
            }),
            _jsx(_components.p, {
                children: "If We need to rely on consent as a legal basis for processing Your information and Your country requires consent from a parent, We may require Your parent's consent before We collect and use that information."
            }),
            _jsx(_components.h2, {
                children: _jsx(_components.strong, {
                    children: "Your California Privacy Rights (California's Shine the Light law)"
                })
            }),
            _jsx(_components.p, {
                children: "Under California Civil Code Section 1798 (California's Shine the Light law), California residents with an established business relationship with us can request information once a year about sharing their Personal Data with third parties for the third parties' direct marketing purposes."
            }),
            _jsx(_components.p, {
                children: "If you'd like to request more information under the California Shine the Light law, and if You are a California resident, You can contact Us using the contact information provided below."
            }),
            _jsx(_components.h2, {
                children: _jsx(_components.strong, {
                    children: "California Privacy Rights for Minor Users (California Business and Professions Code Section 22581)"
                })
            }),
            _jsx(_components.p, {
                children: "California Business and Professions Code Section 22581 allows California residents under the age of 18 who are registered users of online sites, services or applications to request and obtain removal of content or information they have publicly posted."
            }),
            _jsx(_components.p, {
                children: "To request removal of such data, and if You are a California resident, You can contact Us using the contact information provided below, and include the email address associated with Your account."
            }),
            _jsx(_components.p, {
                children: "Be aware that Your request does not guarantee complete or comprehensive removal of content or information posted online and that the law may not permit or require removal in certain circumstances."
            }),
            _jsx(_components.h2, {
                children: _jsx(_components.strong, {
                    children: "Links to Other Websites"
                })
            }),
            _jsx(_components.p, {
                children: "Our Service may contain links to other websites that are not operated by Us. If You click on a third party link, You will be directed to that third party's site. We strongly advise You to review the Privacy Policy of every site You visit."
            }),
            _jsx(_components.p, {
                children: "We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services."
            }),
            _jsx(_components.h2, {
                children: _jsx(_components.strong, {
                    children: "Changes to this Privacy Policy"
                })
            }),
            _jsx(_components.p, {
                children: "We may update Our Privacy Policy from time to time. We will notify You of any changes by posting the new Privacy Policy on this page."
            }),
            _jsx(_components.p, {
                children: 'We will let You know via email and/or a prominent notice on Our Service, prior to the change becoming effective and update the "Last updated" date at the top of this Privacy Policy.'
            }),
            _jsx(_components.p, {
                children: "You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page."
            }),
            _jsx(_components.h2, {
                children: _jsx(_components.strong, {
                    children: "Contact Us"
                })
            }),
            _jsx(_components.p, {
                children: "If you have any questions about this Privacy Policy, You can contact us:"
            }),
            _jsx(_components.p, {
                children: "By visiting this page on our website:"
            }),
            _jsx(_components.p, {
                children: _jsx(_components.a, {
                    href: "https://www.termsfeed.com/live/oneshot.earth/contact",
                    children: "oneshot.earth/contact"
                })
            })
        ]
    });
}
function MDXContent(props = {}) {
    const { wrapper: MDXLayout } = Object.assign({}, _provideComponents(), props.components);
    return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
        children: _jsx(_createMdxContent, props)
    })) : _createMdxContent(props);
}
export default MDXContent;
